const Contact = () => (
  <section className="centered-section contact-section">
    <div className="translucent-box">
  <h2 className="main-heading">Contact</h2>
      <p>Call at <strong>(208) 690-2389</strong></p>
      <p>Email: <a href="mailto:cyberjrg28@yahoo.com" className="contact-link">cyberjrg28@yahoo.com</a></p>
    </div>
  </section>
);

export default Contact;
